var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.clss},[_c('defs',[_c('clipPath',{attrs:{"id":"squircle","clipPathUnits":"objectBoundingBox"}},[_c('path',{attrs:{"d":"M .5 0 C .1 0 0 .1 0 .5 0 .9 .1 1 .5 1 .9 1 1 .9 1 .5 1 .1 .9 0 .5 0 Z"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }